import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    cardContainer: {
      margin: '1%',
      minHeight: '100vh'
    }
  })
